import $ from 'jquery';

$($ => {
	let enabledFilters = {};

	$('.dropdown-filter--filter--header').on('click', function (evt) {
		evt.preventDefault();
		evt.stopPropagation();

		if ($(this).parent().hasClass('open')) {
			$(this).parent().removeClass('open');
		} else {
			$(this).parent().addClass('open');
		}
	});

	$('.filter-options>input').on('change', function () {
		let filterType = $(this).attr('name');
		let filterValue = $(this).val();

		let post_type = $('.article-filters').attr('data-post-type') ?? 'post';

		if (this.checked) {
			// Add the filter to the enabled filters
			let filterNameClean = filterType.replace('[]', '');
			if (filterNameClean in enabledFilters) {
				enabledFilters[filterNameClean].push(filterValue);
			} else {
				enabledFilters[filterNameClean] = [filterValue];
			}
		} else {
			// Remove the filter from the enabled filters
			let filterNameClean = filterType.replace('[]', '');
			if (filterNameClean in enabledFilters) {
				let index = enabledFilters[filterNameClean].indexOf(filterValue);
				if (index > -1) {
					enabledFilters[filterNameClean].splice(index, 1);
				}
			}
		}


		// if we are a radio button make sure we only have the one value in our filters
		if ($(this).attr('type') === 'radio') {
			enabledFilters[filterType.replace('[]', '')] = [filterValue];
		}

		$('body').trigger('filter:change', [post_type, enabledFilters]);
	});

	// Listen for filter change event
	$('body').on('filter:change', (e, post_type, enabledFilters) => {
		// Update the data-to-fetch attribute
		$('.article-filters').attr('data-to-fetch', JSON.stringify(enabledFilters));
		let hxUrl = $('.article-archive-list--inner').attr('data-url');
		// Update our hxUrl to have a get param of to-fetch with the enabled filters
		$('.article-archive-list--inner').attr('hx-get', hxUrl + '?to-fetch=' + JSON.stringify(enabledFilters) + '&type=' + post_type);

		// Trigger the htmx request
		htmx.process('.article-archive-list--inner');
	});
});
